var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"DialogTip"},[_c('div',{staticClass:"dialog"},[_c('div',{staticClass:"dialogText"},[_c('h2',[_vm._v(_vm._s(_vm.text.mesg))])]),_c('el-button',{staticClass:"dialogBtn",attrs:{"type":"primary"},on:{"click":_vm.cancel}},[_vm._v("OK")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }